import { render, staticRenderFns } from "./cModalTurn.vue?vue&type=template&id=0c275238&scoped=true"
import script from "./cModalTurn.vue?vue&type=script&lang=js"
export * from "./cModalTurn.vue?vue&type=script&lang=js"
import style0 from "./cModalTurn.vue?vue&type=style&index=0&id=0c275238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c275238",
  null
  
)

export default component.exports